import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgUsageSelector } from '../../../redux/app/selectors/organization';
import { UsageTable } from './UsageTable';
import { UsageGraphSection } from './UsageGraphSection';

export const TypeUsageStats = () => {
  const usage = useSelector(orgUsageSelector);
  const pieData = [];
  const typesRows = usage.type.map((row) => {
    pieData.push({ name: row.header, value: row.quantity, color: row.color });
    return (
      <tr>
        <td>{row.header}</td>
        <td>{row.averageRate}</td>
        <td>{row.quantity}</td>
        <td>{row.total}</td>
      </tr>
    );
  });

  const pieTableRows = usage.type.map((row) => {
    if (!row.shortHeader) return null;

    return (
      <tr>
        <td>
          <span className="circle" style={{ background: row.color }} />
          &nbsp;&nbsp;
          <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.shortHeader}</span>
        </td>
        <td>
          <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.quantity}</span>
        </td>
      </tr>
    );
  });

  return (
    <>
      <UsageGraphSection datas={pieData} rows={pieTableRows} />
      <UsageTable rows={typesRows} />
    </>
  );
};
